import styled from 'styled-components'
import {
  flexbox,
  FlexboxProps,
  maxHeight,
  MaxHeightProps,
  padding,
  PaddingProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({ shouldForwardProp })<
  FlexboxProps & GapProps & PaddingProps & MaxHeightProps
>`
  position: relative;
  display: flex;
  width: 100%;

  ${flexbox}
  ${gap}
  ${padding}
  ${maxHeight}
`

export const IconHolder = styled.div`
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 104px;
  border-radius: 52px;
  background-color: ${themeGet('colors.background.screen')};
  color: ${themeGet('colors.primary.main')};

  > svg {
    transform: translateY(-50%);
  }
`
